module.exports = __webpack_public_path__ + "media/images/home/add-project-6e596cedb3849e6a75efb192494d9e7f.png";